import AxiosInstance from "./api";

export const AssetCardService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/asset-cards/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/asset-cards/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/asset-cards", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/asset-cards/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/asset-cards/" + id);
  },
};
